import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import page components
import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import PressReleaseGallery from "./pages/PressReleaseGallery";
import ProductCatalog from "./pages/ProductCatalog";
import ContactUs from "./pages/Contact";
import UtpannProduction from "./pages/UtpannProduction";
import ProductDetails from "./pages/ProductDetails";
import ProductDetails2 from "./pages/ProductDetails2";
import ProductDetails9 from "./pages/ProductDetails9";
import ProductDetails10 from "./pages/ProductDetails10";
import ProductDetails11 from "./pages/ProductDetails11";
import ProductDetails13 from "./pages/ProductDetails13";
import ProductDetails3 from "./pages/ProductDetails3";
import ProductDetails4 from "./pages/ProductDetails4";
import ProductDetails5 from "./pages/ProductDetails5";
import ProductDetails6 from "./pages/ProductDetails6";
import ProductDetails7 from "./pages/ProductDetails7";
import ProductDetails8 from "./pages/ProductDetails8";
import ProductDetails12 from "./pages/ProductDetails12";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route
          path="/press-release-gallery"
          element={<PressReleaseGallery />}
        />
        <Route path="/products" element={<ProductCatalog />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/utpann-production" element={<UtpannProduction />} />
        <Route path="/product-details" element={<ProductDetails />} />
        <Route path="/product-details2" element={<ProductDetails2 />} />
        <Route path="/product-details3" element={<ProductDetails3 />} />
        <Route path="/product-details4" element={<ProductDetails4 />} />
        <Route path="/product-details5" element={<ProductDetails5 />} />
        <Route path="/product-details6" element={<ProductDetails6 />} />
        <Route path="/product-details7" element={<ProductDetails7 />} />
        <Route path="/product-details8" element={<ProductDetails8 />} />
        <Route path="/product-details9" element={<ProductDetails9 />} />
        <Route path="/product-details10" element={<ProductDetails10 />} />
        <Route path="/product-details11" element={<ProductDetails11 />} />
        <Route path="/product-details12" element={<ProductDetails12 />} />
        <Route path="/product-details13" element={<ProductDetails13 />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
